import { readableColor, transparentize } from 'polished';

// TODO: Consume from `@passkeys/ui`.
const black = '#181818';
const white = '#ffffff';

function foregroundColor(color: string): string {
  return readableColor(color, black, white);
}

export interface Theme {
  variant: 'glow' | 'flat' | 'dark';
  colors: {
    accentColor?: string;
    collapsed: {
      accentColor?: string;
      backgroundColor?: string;
    };
  };
}

export function calculateColors({ variant, colors }: Theme) {
  const accentColor = colors?.accentColor;

  const isDarkVariant = variant === 'dark';
  const fallbackCollapsedBackgroundColor = isDarkVariant ? black : white;

  const collapsedBackgroundColor =
    colors?.collapsed?.backgroundColor ?? fallbackCollapsedBackgroundColor;
  const collapsedAccentColor = colors?.collapsed?.accentColor ?? accentColor;
  const collapsedTextOpacity = '0.4';
  const collapsedIconOpacity = '0.2';

  let collapsedForegroundColor: string | undefined;
  let collapsedBorderColor: string | undefined;
  let collapsedSkeletonColor: string | undefined;
  let collapsedAvatarForegroundColor: string | undefined;

  try {
    collapsedForegroundColor =
      collapsedBackgroundColor && foregroundColor(collapsedBackgroundColor);
    collapsedBorderColor =
      collapsedForegroundColor &&
      transparentize(0.94, collapsedForegroundColor);
    collapsedSkeletonColor =
      collapsedForegroundColor &&
      transparentize(0.94, collapsedForegroundColor);
    collapsedAvatarForegroundColor =
      collapsedAccentColor && foregroundColor(collapsedAccentColor);
  } catch (error) {
    console.error('Could not calculate colors', error);
  }

  return {
    accentColor,
    collapsedBackgroundColor,
    collapsedForegroundColor,
    collapsedBorderColor,
    collapsedSkeletonColor,
    collapsedTextOpacity,
    collapsedIconOpacity,
    collapsedAccentColor,
    collapsedAvatarForegroundColor,
  };
}
